import React, {ReactElement} from "react";
import {AppBar, Grid, Paper} from "@mui/material";
import {MainFooter} from "../main/MainFooter";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";

type Props = {
    className?: string,
    content: ReactElement,
    minHeight?: string,
};

export const FullPageCard: React.FC<Props> = ({className, content, minHeight}) => <>
    <Grid className={"vh-100" + (className ? ` ${className}` : '')}
          container justifyContent="center" direction="column">
        <Grid item>
            <Container>
                <Grid container justifyContent="center">
                    <Grid item xs={9} sm={6} md={4}>

                        {/*Small header*/}
                        <AppBar id="main-header" className="small" position="relative" elevation={2}>
                            <Toolbar>
                                <img src="/logo_135x30/Mithra_logo.png" alt="Mithra" className="mithra-logo"/>
                            </Toolbar>
                        </AppBar>

                        {/*Content*/}
                        <Paper style={{minHeight: minHeight}} elevation={2} square>
                            {content}
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    </Grid>
    <div style={{position: 'absolute', bottom: 0, left: 0, right: 0}}>
        <MainFooter/>
    </div>
</>;
